<template>
    <div class="select" v-if="activeName">
        <div class="sel_val" @click="showOptionFn" v-if="type == 'pane'">{{activeName}}<i class="el-icon-arrow-down"></i></div>
        <div class="sel_val" @click="showOptionFn" v-if="type == 'grade'">{{activeName.gradeName}}<i class="el-icon-arrow-down"></i></div>
        <div class="sel_val" @click="showOptionFn" v-if="type == 'subject' && activeName">{{activeName.name}}<i class="el-icon-arrow-down"></i></div>
        <div class="option_cont" v-if="showOption && tabList.length > 0">
            <template v-if="type == 'pane'">
                <ul class="sel_option">
                    <li v-for="(tab,index) in tabList" :key="index" :class="{active:activeName == tab}" @click="choseTab(tab)">{{tab}}</li>
                </ul>
            </template>
            <template v-if="type == 'grade'">
                <ul class="sel_option">
                    <li v-for="(tab,index) in tabList" :key="index" :class="{active:activeName == tab}" @click="choseTab(tab)">{{tab.gradeName}}</li>
                </ul>
            </template>
            <template v-if="type == 'subject'">
                <ul class="sel_option">
                    <li v-for="(tab,index) in tabList" :key="index" :class="{active:activeName == tab}" @click="choseTab(tab)">{{tab.name}}</li>
                </ul>
            </template>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            tabList:{
                type:Array,
                default () {
                    return []
                }
            },
            type:{
                type:String,
                default:'pane'
            }
        },
        data(){
            return {
                activeName:null,
                showOption:false,
                selectList:[]
            }
        },
        mounted(){
            let vm = this
            setTimeout(function(){
                vm.selectList = vm.tabList
                vm.activeName = vm.selectList[0]
            },200)
        },
        methods: {
            choseTab(tab){
                this.activeName = tab
                this.showOption = false
                this.$emit("getTab",this.activeName)
            },
            showOptionFn(){
                this.showOption = !this.showOption
            }
        }
    }
</script>
<style lang="less" scoped>
    .zj_warp{
        .select{
            top: 20px;
        }
    }
    .select{
        display: inline-block;
        vertical-align: top;
        font-size: 12px;
        color: #333;
        position: relative;
        .sel_val{
            border-radius: 15px;
            border:1px solid #DCDCDC;
            line-height:20px;
            padding:0 10px 0 10px;
            cursor: pointer;
            i{
                font-weight: bold;
                color: #a0a0a0;
                margin-left: 4px;
            }
        }
        .option_cont{
            position: absolute;z-index: 100;
            border:1px solid #DCDCDC;
            background: #fff;
            border-radius: 2px;
            box-shadow: 0 0 3px #f0f0f0;
            top: 25px;left: 0;
            max-height: 250px;
            overflow: auto;
            width: 100%;
        }
        .sel_option{
            li{
                padding: 5px 10px;
                cursor: pointer;
                white-space:nowrap;
            }
            li.active,
            li:hover{
                background: #F6F8FC;
                color: #4183fc;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/select.vue